import Stripe from '../../../stripe'
import isStripePayment from './is-stripe-payment'

export default (paymentProviders = []) => [
  {
    name: 'Payment Provider',
    prop: 'payment_provider_id',
    type: 'autocomplete',
    references: 'admin/payment_providers',
    referenceProp: 'name'
  },
  {
    name: 'Amount',
    prop: 'amount',
    type: 'text'
  },
  {
    name: 'Payment Date',
    prop: 'payment_date',
    type: 'datetime',
    showIf: resource => !isStripePayment(resource, paymentProviders)
  },
  {
    name: 'Reference Number',
    prop: 'reference_number',
    type: 'text',
    showIf: resource => !isStripePayment(resource, paymentProviders)
  },
  {
    name: 'Stripe',
    prop: 'stripe_charge_token',
    type: 'component',
    component: Stripe,
    showIf: resource => isStripePayment(resource, paymentProviders)
  }
]
